import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { logout } from "../../store/slices/auth";

const DocsPending = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    window.location.href = "/login";
  };

  return (
    <Container>
      <Card>
        <Icon>✓</Icon>
        <Title>Documents Submitted Successfully</Title>
        <Message>
          Please wait while our team reviews your business documents.
          You will be able to access the full dashboard once your documents are verified.
        </Message>
        <StatusBadge>Under Review</StatusBadge>
        <LogoutButton onClick={handleLogout}>Sign Out</LogoutButton>
      </Card>
    </Container>
  );
};

export default DocsPending;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8fafc;
  font-family: "Inter", sans-serif;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 48px 40px;
  max-width: 480px;
  text-align: center;
`;

const Icon = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #d1f2eb;
  color: #16a085;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
`;

const Title = styled.h2`
  font-size: 22px;
  color: #2c3e50;
  margin-bottom: 12px;
`;

const Message = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 8px 20px;
  border-radius: 20px;
  background: #fcf3cf;
  color: #b9770e;
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  margin-bottom: 32px;
`;

const LogoutButton = styled.button`
  padding: 10px 24px;
  background: transparent;
  border: 1px solid #ccc;
  color: #555;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;
